import { IconProps } from "../../../types/style";

const BoxCoveredIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M22.5 9.75C22.09 9.75 21.75 9.41 21.75 9V7C21.75 4.42 20.08 2.75 17.5 2.75H7.5C4.92 2.75 3.25 4.42 3.25 7V9C3.25 9.41 2.91 9.75 2.5 9.75C2.09 9.75 1.75 9.41 1.75 9V7C1.75 3.56 4.06 1.25 7.5 1.25H17.5C20.94 1.25 23.25 3.56 23.25 7V9C23.25 9.41 22.91 9.75 22.5 9.75Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M17.5 22.75H7.5C4.06 22.75 1.75 20.44 1.75 17V15C1.75 14.59 2.09 14.25 2.5 14.25C2.91 14.25 3.25 14.59 3.25 15V17C3.25 19.58 4.92 21.25 7.5 21.25H17.5C20.08 21.25 21.75 19.58 21.75 17V15C21.75 14.59 22.09 14.25 22.5 14.25C22.91 14.25 23.25 14.59 23.25 15V17C23.25 20.44 20.94 22.75 17.5 22.75Z"
          fill={color}
        />
        <path
          d="M16.8999 8.20999L13.1399 6.17996C12.7399 5.96996 12.2699 5.96996 11.8699 6.17996L8.10992 8.20999C7.83992 8.35999 7.66992 8.64995 7.66992 8.97995C7.66992 9.30995 7.83992 9.59997 8.10992 9.74997L11.8699 11.78C12.0699 11.89 12.2899 11.94 12.5099 11.94C12.7299 11.94 12.9499 11.89 13.1499 11.78L16.9099 9.74997C17.1799 9.59997 17.3499 9.30995 17.3499 8.97995C17.3399 8.64995 17.1699 8.35999 16.8999 8.20999Z"
          fill={color}
        />
        <path
          d="M11.24 12.4699L7.73999 10.7199C7.46999 10.5899 7.15998 10.6 6.89998 10.76C6.63998 10.92 6.48999 11.1899 6.48999 11.4899V14.7999C6.48999 15.3699 6.80999 15.89 7.31999 16.14L10.82 17.89C10.94 17.95 11.07 17.9799 11.21 17.9799C11.37 17.9799 11.52 17.9399 11.66 17.8499C11.92 17.6899 12.07 17.4199 12.07 17.1199V13.8099C12.07 13.2399 11.76 12.7299 11.24 12.4699Z"
          fill={color}
        />
        <path
          d="M18.0899 10.76C17.8299 10.6 17.5199 10.5899 17.2499 10.7199L13.7499 12.4699C13.2399 12.7299 12.9199 13.2399 12.9199 13.8099V17.1199C12.9199 17.4199 13.0699 17.6899 13.3299 17.8499C13.4699 17.9399 13.6199 17.9799 13.7799 17.9799C13.9099 17.9799 14.0399 17.95 14.1699 17.89L17.6699 16.14C18.1799 15.88 18.4999 15.3699 18.4999 14.7999V11.4899C18.4999 11.1899 18.3499 10.92 18.0899 10.76Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BoxCoveredIcon;
